// AI-GENERATED with some modifications

/**
 * Team Service - API calls related to team management
 */

/**
 * Get suggested team members for a specific supplier
 * @param {Object} authAxios - Authenticated axios instance
 * @param {string} supplierNumber - The supplier number to get suggestions for
 * @returns {Promise<Array<{racfId: string, firstName: string, lastName: string, note: string}>} Array of suggested team members
 */
export const getSuggestedTeamMembers = async (authAxios, supplierNumber) => {
    try {
        const response = await authAxios.get(`/v1/team/members/suggested/${supplierNumber}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching suggested team members for supplier ${supplierNumber}:`, error);
        throw error;
    }
};
